export const _setNewCmpForm = (state, action) => {
  state.newCmpForm = action.payload;
};

export const _setCommunityBasedProvider = (state, action) => {
  state.communityBasedProvider = action.payload;
};

export const _setCounselingStaffAssigned = (state, action) => {
  state.counselingStaffAssigned = action.payload;
};

export const _setOracCmpDt1 = (state, action) => {
  state.oracCmpDt1 = action.payload;
};
export const _setOrasCmpDt2 = (state, action) => {
  state.orasCmpDt2 = action.payload;
};
export const _setOrasCmpDt3 = (state, action) => {
  state.orasCmpDt3 = action.payload;
};


export const _setOrasGls1 = (state, action) => {
  state.orasGls1 = action.payload;
};
export const _setOrasGls2 = (state, action) => {
  state.orasGls2 = action.payload;
};
export const _setOrasGls3 = (state, action) => {
  state.orasGls3 = action.payload;
};

export const _setOrasObj1 = (state, action) => {
  state.orasObj1 = action.payload;
};
export const _setOrasObj2 = (state, action) => {
  state.orasObj2 = action.payload;
};
export const _setOrasObj3 = (state, action) => {
  state.orasObj3 = action.payload;
};

export const _setOrasTgtDt1 = (state, action) => {
  state.orasTgtDt1 = action.payload;
};
export const _setOrasTgtDt2 = (state, action) => {
  state.orasTgtDt2 = action.payload;
};
export const _setOrasTgtDt3 = (state, action) => {
  state.orasTgtDt3 = action.payload;
};



export const _setRevisionGoals1 = (state, action) => {
  state.revisionGoals1 = action.payload;
};

export const _setRevisionGoals2 = (state, action) => {
  state.revisionGoals2 = action.payload;
};
export const _setRevisionObjectives1 = (state, action) => {
  state.revisionObjectives1 = action.payload;
};

export const _setRevisionObjectives2 = (state, action) => {
  state.revisionObjectives2 = action.payload;
};

export const _setRevisionTargetDate1 = (state, action) => {
  state.revisionTargetDate1 = action.payload;
};

export const _setRevisionTargetDate2 = (state, action) => {
  state.revisionTargetDate2 = action.payload;
};

export const _setRevisionCompletedOn1 = (state, action) => {
  state.revisionCompletedOn1 = action.payload;
};

export const _setRevisionCompletedOn2 = (state, action) => {
  state.revisionCompletedOn2 = action.payload;
};

export const _setDischargeGoals1 = (state, action) => {
  state.dischargeGoals1 = action.payload;
};

export const _setDischargeGoals2 = (state, action) => {
  state.dischargeGoals2 = action.payload;
};

export const _setDischargeObjectives1 = (state, action) => {
  state.dischargeObjectives1 = action.payload;
};

export const _setDischargeObjectives2 = (state, action) => {
  state.dischargeObjectives2 = action.payload;
};

export const _setDischargeTargetDate1 = (state, action) => {
  state.dischargeTargetDate1 = action.payload;
};

export const _setDischargeTargetDate2 = (state, action) => {
  state.dischargeTargetDate1 = action.payload;
};

export const _setComments = (state, action) => {
  state.comments = action.payload;
};

export const _setParticipant1 = (state, action) => {
  state.participant1 = action.payload;
};

export const _setParticipant2 = (state, action) => {
  state.participant2 = action.payload;
};

export const _setParticipant3 = (state, action) => {
  state.participant3 = action.payload;
};

export const _setParticipant4 = (state, action) => {
  state.participant4 = action.payload;
};

export const _setParticipant5 = (state, action) => {
  state.participant5 = action.payload;
};

export const _setParticipant6 = (state, action) => {
  state.participant6 = action.payload;
};

export const _setCss1 = (state, action) => {
  state.css1 = action.payload;
};

export const _setCss2 = (state, action) => {
  state.css2 = action.payload;
};

export const _setCss3 = (state, action) => {
  state.css3 = action.payload;
};

export const _setCss4 = (state, action) => {
  state.css4 = action.payload;
};

export const _setCss5 = (state, action) => {
  state.css5 = action.payload;
};

export const _setCss6 = (state, action) => {
  state.css6 = action.payload;
};

export const _setScss1 = (state, action) => {
  state.scss1 = action.payload;
};

export const _setScss2 = (state, action) => {
  state.scss2 = action.payload;
};

export const _setScss3 = (state, action) => {
  state.scss3 = action.payload;
};

export const _setScss4 = (state, action) => {
  state.scss4 = action.payload;
};

export const _setScss5 = (state, action) => {
  state.scss5 = action.payload;
};

export const _setScss6 = (state, action) => {
  state.scss6 = action.payload;
};

export const _setRvwDate1 = (state, action) => {
  state.rvwDate1 = action.payload;
};

export const _setRvwDate2 = (state, action) => {
  state.rvwDate2 = action.payload;
};

export const _setRvwDate3 = (state, action) => {
  state.rvwDate3 = action.payload;
};

export const _setRvwDate4 = (state, action) => {
  state.rvwDate4 = action.payload;
};

export const _setRvwDate5 = (state, action) => {
  state.rvwDate5 = action.payload;
};

export const _setRvwDate6 = (state, action) => {
  state.rvwDate6 = action.payload;
};
